export default __webpack_public_path__ + "static/mark-transactions-7719a7103eb22d9878002b8842a514fb.gif";